export default "__VITE_ASSET__NyUnmp8q__"